import React, { useState, FC } from "react";
import {
  Dropdown as BaseDropDown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";

type Props = {
  label: string;
  dropdownClassName?: string;
  toggleClassName?: string;
  dropdownMenuClassName?: string;
};

const Dropdown: FC<Props> = ({
  label,
  dropdownClassName,
  toggleClassName,
  dropdownMenuClassName,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  function handleToggled(): void {
    setIsOpen((prevState) => !prevState);
  }

  return (
    <BaseDropDown
      className={dropdownClassName}
      isOpen={isOpen}
      toggle={handleToggled}
    >
      <DropdownToggle
        className={toggleClassName}
        caret={true}
        data-toggle="dropdown"
        aria-expanded={isOpen}
      >
        {label}
      </DropdownToggle>
      <DropdownMenu className={dropdownMenuClassName}>{children}</DropdownMenu>
    </BaseDropDown>
  );
};

export default Dropdown;
